import { definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";
import {
  buildPrimaryScale,
  buildSecondaryScale,
  DEFAULT_MENU_HOVER,
  DEFAULT_THEME_COLORS,
  getContrastColor,
} from "../utils/themeColorScale";

// OCV neutral grays, the same in light and dark. Shade 950 stays Aura's.
const surface = {
  0: "#ffffff",
  50: "#fafafa",
  70: "#f5f5f5",
  100: "#f0f0f0",
  200: "#e0e0e0",
  300: "#d0d0d0",
  400: "#a0a0a0",
  500: "#707070",
  600: "#505050",
  700: "#404040",
  800: "#303030",
  900: "#202020",
};

const OCV = definePreset(Aura, {
  semantic: {
    primary: buildPrimaryScale(DEFAULT_THEME_COLORS.primary),
    // OCV accent: not an Aura token. useUserThemeColors updates it with the main color.
    secondary: {
      ...buildSecondaryScale(DEFAULT_THEME_COLORS.secondary),
      soft: DEFAULT_MENU_HOVER,
      contrastColor: getContrastColor(DEFAULT_THEME_COLORS.secondary),
    },
    colorScheme: {
      light: {
        surface,
        primary: {
          color: "{primary.900}",
          contrastColor: "#ffffff",
          hoverColor: "{primary.800}",
          activeColor: "{primary.950}",
        },
        highlight: {
          background: "color-mix(in srgb, {secondary.500}, white 88%)",
          focusBackground: "{secondary.100}",
          color: "{primary.900}",
          focusColor: "{primary.950}",
        },
      },
      dark: {
        surface,
        // Primary stays navy (shade 900, white text) in dark mode: shade 400 reads as a disabled gray
        primary: {
          color: "{primary.900}",
          contrastColor: "#ffffff",
          hoverColor: "{primary.800}",
          activeColor: "{primary.950}",
        },
        highlight: {
          background: "color-mix(in srgb, {secondary.500}, transparent 78%)",
          focusBackground: "color-mix(in srgb, {surface.400}, transparent 76%)",
          color: "rgba(255,255,255,.87)",
          focusColor: "rgba(255,255,255,.87)",
        },
      },
    },
  },
  components: {
    button: {
      colorScheme: {
        light: {
          root: {
            secondary: {
              background: "{secondary.500}",
              hoverBackground: "{secondary.600}",
              activeBackground: "{secondary.700}",
              borderColor: "{secondary.500}",
              hoverBorderColor: "{secondary.600}",
              activeBorderColor: "{secondary.700}",
              color: "{secondary.contrast.color}",
              hoverColor: "{secondary.contrast.color}",
              activeColor: "{secondary.contrast.color}",
              focusRing: {
                color: "{secondary.500}",
                shadow: "none",
              },
            },
          },
        },
        dark: {
          root: {
            secondary: {
              background: "{secondary.400}",
              hoverBackground: "{secondary.300}",
              activeBackground: "{secondary.200}",
              borderColor: "{secondary.400}",
              hoverBorderColor: "{secondary.300}",
              activeBorderColor: "{secondary.200}",
              color: "{primary.950}",
              hoverColor: "{primary.950}",
              activeColor: "{primary.950}",
              focusRing: {
                color: "{secondary.400}",
                shadow: "none",
              },
            },
          },
        },
      },
    },
  },
});

export default OCV;
